import { render } from "./History.vue?vue&type=template&id=2384127a"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v1/History.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2384127a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2384127a', __exports__)) {
    api.reload('2384127a', __exports__)
  }
  
  module.hot.accept("./History.vue?vue&type=template&id=2384127a", () => {
    api.rerender('2384127a', render)
  })

}


export default __exports__